import React from 'react';

import {CallHistoryContext} from './callHistory.context';
import {callHistoryService} from '../services/CallHistory.service';

export const CallHistoryProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    return (
        <CallHistoryContext.Provider value={callHistoryService}>
            {children}
        </CallHistoryContext.Provider>
    );
};
